export default "__VITE_ASSET__13855a29__"